import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Input, TextArea } from 'semantic-ui-react';
import * as classes from './classes.module.scss';

export default class Editor extends PureComponent {
  static propTypes = {
    value: PropTypes.string,
    setValue: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    text: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = { editing: false, newValue: '' };
  }

  input = React.createRef();

  startEditing = () => {
    const { value } = this.props;
    this.setState({ editing: true, newValue: value }, () => {
      this.input.current.focus();
    });
  };

  onChange = (event) => this.setState({ newValue: event.target.value });

  onCancel = () => this.setState({ editing: false });

  onSave = () => {
    const { newValue } = this.state;
    const { setValue } = this.props;
    setValue(newValue);
    this.onCancel();
  };

  onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.onSave();
      return;
    }

    if (e.key === 'Escape') {
      e.preventDefault();
      this.onCancel();
    }
  };

  render() {
    const { editing, newValue } = this.state;
    const { name, value, text } = this.props;

    const C = text ? TextArea : Input;
    const content = editing ? (
      <div className={ classes.inlineEdit }>
        <C
          ref={ this.input }
          value={ newValue }
          className={ classes.input }
          onChange={ this.onChange }
          onKeyDown={ this.onKeyDown }
          onBlur={ this.onSave }
        />
      </div>
    ) : (
      <button
        onClick={ this.startEditing }
        className={ classes.editButton }
        type="button"
      >
        { value }
      </button>
    );
    return (
      <div className={ classes.editor }>
        <span>
          { name }
          :
        </span>
        { content }
      </div>
    );
  }
}
